<div class="header-row">
    @for (curElement of headlines(); track $index) {
        <app-atomic class="header" [blueprint]="curElement"></app-atomic>
    }
    @if (exportAvailable) {
        <sd-6-17-1-dropdown #tileMenu class="tile-menu" distance="4" rounded placement="bottom-end" data-export-ignore>
            <sd-6-17-1-button variant="tertiary" size="sm" slot="trigger" [attr.aria-label]="'dashboard.exportMenu' | transloco" [attr.title]="'dashboard.exportMenu' | transloco">
                <sd-6-17-1-icon library="{{ iconLibrary }}" name="system/download"></sd-6-17-1-icon>
            </sd-6-17-1-button>
            <sd-6-17-1-menu class="export-menu">
                @for (curFormat of exportFormats; track curFormat) {
                    <sd-6-17-1-menu-item sdCloseOnSelect (click)="onExportClick(curFormat)">
                        {{ curFormat }}
                    </sd-6-17-1-menu-item>
                }
            </sd-6-17-1-menu>
        </sd-6-17-1-dropdown>
    }
    <sd-6-17-1-tooltip class="focus-button" trigger="hover" close-trigger="hover" [content]="focusLabel() | transloco" placement="top" data-export-ignore>
        <sd-6-17-1-button variant="tertiary" size="sm" (click)="onFocusClick($event)">
            <sd-6-17-1-icon
                library="{{ iconLibrary }}"
                [name]="focusIcon()"></sd-6-17-1-icon>
        </sd-6-17-1-button>
    </sd-6-17-1-tooltip>
</div>
@for (curElement of content(); track $index) {
    <app-atomic class="content" [blueprint]="curElement"></app-atomic>
}
@for (curElement of footnotes(); track $index) {
    <!-- <app-atomic class="footer" [blueprint]="curElement"></app-atomic> -->
}
